import { HttpCode } from 'types/common';

export const HTTP_CODE: { [key: string]: HttpCode } = {
  OK: 200,
  NOT_FOUND: 404,
  SERVER_ERROR: 500,
};

export const REGION_ID = {
  MOSCOW: '34',
  ROSTOV: '504',
  SPB: '506',
  OMSK: '509',
};

export const OPTIMIZED_IMAGE_WIDTH_MOBILE = '600';
export const OPTIMIZED_IMAGE_WIDTH_DESKTOP = '2000';

export const SHOP_URL = '/shop';

export const PATH_STORE_WITHOUT_LINKS = ['almaty'];

export const enum LogLevel {
  Info = 'info',
  Error = 'error',
}
